import styled from '@emotion/styled'
import React from 'react'

import type { StyleProps } from '@/types'

import type { Props as DatePeriodPicker } from './DatePeriodPicker'
import DatePicker from './DatePicker'

type Props = {
  start: DatePeriodPicker
  end: DatePeriodPicker
} & StyleProps

const RangePeriodPicker = ({ className, style, start, end }: Props) => {
  return (
    <S.RangePeriodPicker className={className} style={style}>
      <DatePicker.Period {...start} />
      &nbsp;~&nbsp;
      <DatePicker.Period {...end} />
    </S.RangePeriodPicker>
  )
}

export default RangePeriodPicker

const S = {
  RangePeriodPicker: styled.div`
    display: flex;
    align-items: center;
  `,
}
